import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { BdbSessionStrgService } from '@npm-bbta/bbog-cm-auth-lib';
import { environment } from '../../../environments/environment';
import { AuthenticationRnecService } from '../authentication-rnec/services/authentication-rnec.service';
import { MachineTypeEnum } from '../enums/machine-type.enum';
import { MediumTypeEnum } from '../enums/medium-type.enum';
import { ServiceErrorEnum } from '../enums/service-error.enum';
import { SessionStorageKeysEnum } from '../models/session-storage-keys-enum';
import { AdviserService } from '../shared/adviser.service';
import { BdbAbstentionService } from '../shared/bdb-abstention.service';
import { EventsService } from '../shared/bdb-event.service';
import { ChannelService } from '../shared/channel.service';
import { DispatcherService } from '../shared/dispatcher.service';
import { FairService } from '../shared/fair.service';
import { ParticipantService } from '../shared/participant.service';
import { RedirectService } from '../shared/redirect.service';
import { SingleSessionService } from '../shared/single-session.service';
import * as projectInfo from '../../../package.json';
import { IpUtil } from '../shared/util/IpUtil';
import { BdbBffService } from '../shared/bdb-bff.service';
import { InitialLoad } from '../shared/assistedStorage/models/IAssitedStorage';
import { AssistedStorage } from '../shared/assistedStorage/assistedStorage';
import { CustomLogger } from '@npm-bbta/bbog-sg-frontend-logs-lib';

const logger = new CustomLogger('app-bdb-handler', 'gray')

@Component({
    selector: 'app-bdb-handler',
    templateUrl: './bdb-handler.component.html',
    styleUrls: ['./bdb-handler.component.scss']
})
export class BdbHandlerComponent implements OnInit, AfterViewInit {

    @ViewChild('loader') loaderBdb: ElementRef;
    @ViewChild('modal') modalBdb: ElementRef;

    modalFunctionYes: Function;
    initialLoad: InitialLoad;

    constructor(
        private readonly dispatcherService: DispatcherService,
        private readonly authenticationRnecService: AuthenticationRnecService,
        private readonly redirectService: RedirectService,
        private readonly fairService: FairService,
        private readonly routes: Router,
        private readonly sessionStorageService: BdbSessionStrgService,
        private readonly ipUtil: IpUtil,
        private readonly channelService: ChannelService,
        private readonly singleSessionService: SingleSessionService,
        private readonly participantService: ParticipantService,
        private readonly adviserService: AdviserService,
        private readonly eventsService: EventsService,
        private readonly bdbAbstentionService: BdbAbstentionService,
        private readonly bffService: BdbBffService,
        private readonly assistedStorage: AssistedStorage
    ) {
    }

    async ngOnInit() {
        // @ts-ignore
        logger.error(`Starting ${projectInfo.name}...${projectInfo.version}...`);
    }

    ngAfterViewInit(): void {
        this.loaderBdb.nativeElement.openLoader();
        this.getFullScreeen();
        this.getQueryParams();
        this.checkEmptyDataSite();
        this.handlerRoute();
    }

    async handlerRoute() {
        window.scrollTo(0, 0);
        this.initialLoad = await this.bffService.getParamsToInitialLoad('initialLoad');
        await this.assistedStorage.saveAll({initialLoad: this.initialLoad});
        let specificProductInfoUuid = this.sessionStorageService.get(SessionStorageKeysEnum.SPECIFIC_PRODUCT_INFO_UUID);
        const site = this.sessionStorageService.get(SessionStorageKeysEnum.SITE);
        let uuidControl = true;
        if (site === '5') {
            try {
                const responseFromDispatcher = await this.getInfoFromUuid(specificProductInfoUuid);
                const uuid = responseFromDispatcher.specificProductInfo.uuid;
                if (!!uuid) {
                    specificProductInfoUuid = uuid;
                }
            } catch (error) {
                uuidControl = false;
            }
        }
        if (uuidControl) {
            try {
                const responseFromDispatcher = await this.getInfoFromUuid(specificProductInfoUuid);
                await this.setInfoSessionStorage(responseFromDispatcher);
                await this.servicesActions();
            } catch (error) {
                logger.log('Error --> ', error);
                this.callModalServiceError(ServiceErrorEnum.GET_DATA_DISPATCHER_ERROR, () => {
                    this.redirectService.quit();
                });
            }
        } else {
            this.callModalServiceError(ServiceErrorEnum.GET_DATA_DISPATCHER_ERROR, () => {
                this.redirectService.quit();
            });
        }
    }

    async getInfoFromUuid(uuid) {
        return new Promise<any>((resolve, reject) => {
            if (this.initialLoad.useSandboxDispatcher) {
                this.dispatcherService.getInfoFromUuidSandbox(uuid)
                    .then((responseFromDispatcher) => {
                        resolve(responseFromDispatcher);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            } else {
                this.dispatcherService.getInfoFromUuid(uuid).subscribe(async (responseFromDispatcher) => {
                    if (responseFromDispatcher.ok) {
                        const savedOkResponseFromDispatcher = JSON.parse(responseFromDispatcher._body);
                        resolve(savedOkResponseFromDispatcher);
                    } else {
                        logger.log('Error getInfoFromUuidSandbox');
                        reject(null);
                    }
                }, (error) => {
                    reject(error);
                });
            }
        });
    }

    async setInfoSessionStorage(responseFromDispatcher: any) {

        const journey = responseFromDispatcher.specificProductInfo.Journey;
        if (!!journey) {
            this.sessionStorageService.save(SessionStorageKeysEnum.JOURNEY, journey);
        }
        const typeTx = responseFromDispatcher.specificProductInfo.typeTx;
        if (!!typeTx) {
            this.sessionStorageService.save(SessionStorageKeysEnum.JOURNEY, typeTx);
        }

        const sellerDocumentLauncher = responseFromDispatcher.specificProductInfo.sellerIdentityNumber ||
            responseFromDispatcher.specificProductInfo.sellerId;
        if (!!sellerDocumentLauncher) {
            this.sessionStorageService.save(SessionStorageKeysEnum.SELLER_IDENTITY_NUMBER_LAUNCHER, sellerDocumentLauncher);
        }
        const mediumType = responseFromDispatcher.specificProductInfo.mediumType;
        if (!!mediumType) {
            this.sessionStorageService.save(SessionStorageKeysEnum.MEDIUM_TYPE, mediumType);
        }
        const uuid = responseFromDispatcher.uuid;
        this.sessionStorageService.save(SessionStorageKeysEnum.UUID, uuid);
        const identityType = responseFromDispatcher.specificProductInfo.identificationType || 'C';
        this.sessionStorageService.save(SessionStorageKeysEnum.IDENTITY_TYPE, identityType);

        const publicIp = await this.ipUtil.getPublicIP();
        this.sessionStorageService.save(SessionStorageKeysEnum.PUBLIC_IP, publicIp);

        const privateIp = await this.getPrivateIp(responseFromDispatcher);
        this.sessionStorageService.save(SessionStorageKeysEnum.PRIVATE_IP, privateIp);

        if (!!responseFromDispatcher.authInfo) {
            this.sessionStorageService.save(SessionStorageKeysEnum.AUTH_INFO, responseFromDispatcher.authInfo);
            const idNumber = responseFromDispatcher.authInfo.documentId.replace(/\D/g, '');
            if (this.isValidIdentityNumber(idNumber)) {
                this.sessionStorageService.save(SessionStorageKeysEnum.IDENTITY_NUMBER, idNumber)
            }
            const cellphoneNumber = responseFromDispatcher.authInfo.cellNumber;
            if (this.isValidCellphoneNumber(cellphoneNumber)) {
                this.sessionStorageService.save(SessionStorageKeysEnum.CELL_PHONE_NUMBER, cellphoneNumber)
            }
            const email = responseFromDispatcher.authInfo.email;
            if (!!email) {
                this.sessionStorageService.save(SessionStorageKeysEnum.EMAIL, email);
            }
            const { day, month, year } = responseFromDispatcher.authInfo.expedition;
            const expd = {
                expday: day,
                expmonth: month,
                expyear: year
            }
            this.sessionStorageService.save(SessionStorageKeysEnum.EXPDATE, JSON.stringify(expd))
        }

        if (this.sessionStorageService.get(SessionStorageKeysEnum.SITE) === '3') {
            this.saveIfExists(SessionStorageKeysEnum.CC_REDIRECT_PILOT, responseFromDispatcher.specificProductInfo['redirect-pilot']);
            this.saveIfExists(SessionStorageKeysEnum.ESTRATEGIA_MARCA_TC, responseFromDispatcher.specificProductInfo['estrategiaMarcaTC']);
            this.saveIfExists(SessionStorageKeysEnum.PROD_SOLI_TARJETA1_CONVENIO, responseFromDispatcher.specificProductInfo['prodSoliTarjeta1Convenio']);
            this.saveIfExists(SessionStorageKeysEnum.CC_REDIRECT_LANDING_URL, responseFromDispatcher.specificProductInfo['redirectLandingUrl']);
        }

    }

    isValidIdentityNumber(idNumber: string) {
        const validLength = idNumber && idNumber.length > 5 && idNumber.length !== 9;
        const pattern = new RegExp(/^(?!0\w*)(\d{6,8}|\d{10})$/);
        const validPattern = pattern.test(idNumber);
        return validLength && validPattern;
    }

    private isValidCellphoneNumber(cellphone: string) {
        const pattern = new RegExp(/[3](01|02|03|04|05|06|10|11|12|13|14|15|16|00|17|18|19|20|21|22|23|50|51)[1-9]{1}[0-9]{6}/);
        return pattern.test(cellphone);
    }

    async servicesActions() {
        const privateIp = this.sessionStorageService.get(SessionStorageKeysEnum.PRIVATE_IP);
        let parsedResponseBody = null;
        try {
            const parsedResponse = await this.authenticationRnecService.OfficeDataByIP(privateIp);
            logger.log('Response from fetch OfficeDataByIP ------>', parsedResponse);
            if (parsedResponse.status === 200) {
                parsedResponseBody = environment.useMDMTVSEndpoint ? parsedResponse.body : parsedResponse;
            }
        } catch (error) {
            logger.log('Error -->', error)
        }
        if (!!parsedResponseBody) {
            environment.useMDMTVSEndpoint ? this.saveDataOfficeByIPTVS(parsedResponseBody) : this.saveDataOfficeByIPOLD(parsedResponseBody);
            const officeValidate = await this.getOffice();
            if (!!officeValidate) {
                this.sessionStorageService.save(SessionStorageKeysEnum.OFFICE_NAME, officeValidate.trim());
                try {
                    const responseSeller = await this.fairService.getSeller();
                    await this.factorConditionals(responseSeller);
                } catch (error) {
                    this.callModalServiceError(ServiceErrorEnum.GET_SELLER_SERVICE_ERROR, () => {
                        location.reload();
                    });
                }
            } else {
                this.callModalServiceError(ServiceErrorEnum.GET_OFFICE_INFO_BY_CODE_SERVICE_ERROR, () => {
                    location.reload();
                });
            }
        } else {
            this.callModalServiceError(ServiceErrorEnum.GET_OFFICE_BY_IP_SERVICE_ERROR, () => {
                location.reload();
            });
        }
    }

    async factorConditionals(responseSeller) {
        if (responseSeller.body.code === 200) {
            try {
                this.saveDataSeller(responseSeller);
                const channelValidate = this.checkChannelConditionsToBlock();
                if (channelValidate.state) {
                    //bff office
                    const mediumType = channelValidate.validationResume.mediumType;
                    const site = this.sessionStorageService.get(SessionStorageKeysEnum.SITE);
                    await this.bffService.getParamsToBff(mediumType, site);
                    const validateOfficeCode = this.sessionStorageService.get(SessionStorageKeysEnum.VALIDATE_OFFICE_CODE);
                    const hardware = this.sessionStorageService.get(SessionStorageKeysEnum.HARDWARE);
                    if (validateOfficeCode === 'true' && hardware === 'old') {
                        const officeCod = this.sessionStorageService.get(SessionStorageKeysEnum.OFFICE_CODE);
                        if (officeCod === 'null' || officeCod === 'undefined') {
                            this.callModalServiceError(ServiceErrorEnum.VALIDATE_CODE_OFFICE_ERROR, () => {
                                location.reload();
                            });
                        } else {
                            await this.redirectIdentity();
                        }
                    } else {
                        await this.redirectIdentity();
                    }
                } else {
                    this.callModalServiceError(ServiceErrorEnum.WRONG_CHANNEL_ERROR, () => {
                        location.reload();
                    });
                }
            } catch (error) {
                this.callModalServiceError(ServiceErrorEnum.SAVE_DATA_SELLER_ERROR, () => {
                    location.reload();
                });
            }
        } else if (responseSeller.body.code === 404) {
            this.callModalServiceError(ServiceErrorEnum.GET_SELLER_NOT_FOUND_ERROR, () => {
                location.reload();
            });
        } else {
            this.callModalServiceError(ServiceErrorEnum.GET_SELLER_SERVICE_ERROR, () => {
                location.reload();
            });
        }
    }

    async redirectIdentity() {
        const identityNumber = this.sessionStorageService.get(SessionStorageKeysEnum.IDENTITY_NUMBER);
        const expDate = this.sessionStorageService.get(SessionStorageKeysEnum.EXPDATE);
        if (!!identityNumber && !!expDate) {
            this.singleSessionService.initIntervalCallSingleSession(identityNumber,
                this.sessionStorageService.get(SessionStorageKeysEnum.SELLER_IDENTITY_NUMBER_LAUNCHER),
                this.sessionStorageService.get(SessionStorageKeysEnum.SPECIFIC_PRODUCT_INFO_UUID));
            if (environment.enableParticipantStateIAC) {
                await this.participantService.getParticipantStateWithSandboxV3(
                    this.sessionStorageService.get(SessionStorageKeysEnum.IDENTITY_NUMBER))
                    .then(async response => {
                        this.sessionStorageService.save(SessionStorageKeysEnum.CUSTOMER_STATE, atob(response.body));
                        await this.generateUuid().then(async (uuidAuth) => {
                            this.sessionStorageService.save(SessionStorageKeysEnum.UUID_AUTH, uuidAuth.toString());
                            this.updateClientAssociationWithAdviser();
                            await this.redirect();
                        }).catch(() => {
                            this.callModalServiceError(ServiceErrorEnum.SAVE_DATA_DISPATCHER_ERROR, () => {
                                this.redirectService.quit();
                            });
                        });
                    })
                    .catch(error => {
                        logger.log('Error participant state service --> ', error);
                        this.callModalServiceError(ServiceErrorEnum.CUSTOMER_STATE_ERROR, () => {
                            this.redirectService.quit();
                        });
                    })
            } else {
                this.participantService.getParticipantState(this.sessionStorageService.get(SessionStorageKeysEnum.IDENTITY_NUMBER))
                    .subscribe(async (response) => {
                        if (response.status === 201) {
                            this.sessionStorageService.save(SessionStorageKeysEnum.CUSTOMER_STATE, atob(response._body));
                            await this.generateUuid().then(async (uuidAuth) => {
                                this.sessionStorageService.save(SessionStorageKeysEnum.UUID_AUTH, uuidAuth.toString());
                                this.updateClientAssociationWithAdviser();
                                await this.redirect();
                            }).catch(() => {
                                this.callModalServiceError(ServiceErrorEnum.SAVE_DATA_DISPATCHER_ERROR, () => {
                                    this.redirectService.quit();
                                });
                            });
                        } else {
                            this.sessionStorageService.save(SessionStorageKeysEnum.MILESTONE, SessionStorageKeysEnum.INGRESO_AUTENTICADOR);
                            this.callModalServiceError(ServiceErrorEnum.CUSTOMER_STATE_ERROR, () => {
                                this.redirectService.quit();
                            });
                        }
                    });
            }
        } else {
            this.loaderBdb.nativeElement.closeLoader();
            this.routes.navigate(['identity-number']);
        }
    }

    async redirect() {
        const dataEvent = this.eventsService.prepareEventAcceptance(1);
        this.eventsService.sendEvent(dataEvent).subscribe(_ => {
        });
        this.sessionStorageService.save(SessionStorageKeysEnum.MILESTONE, SessionStorageKeysEnum.INGRESO_AUTENTICADOR);
        const isAllowedToContinue = await this.bdbAbstentionService.checkAbstentionList();
        if (!isAllowedToContinue) {
            this.callModalServiceError(ServiceErrorEnum.ABSTENTION_LIST_ERROR, () => {
                location.reload();
            });
        } else {
            this.loaderBdb.nativeElement.closeLoader();
            this.routes.navigate(['regulation-rnec']);
        }
    }

    updateClientAssociationWithAdviser() {
        if (this.adviserService.isAuthAdviserEnabled()) {
            this.adviserService.updateClientAssociation().subscribe(response => {
                logger.log('RESPONSE updateClientAssociationWithAdviser: ', response);
            }, error => {
                logger.log('ERROR updateClientAssociationWithAdviser: ', error);
                this.callModalServiceError(ServiceErrorEnum.CLIENT_ASSOCIATION_WITH_SELLER_SERVICE_ERROR, () => {
                    this.redirectService.quit();
                });
            });
        }
    }

    private async generateUuid(): Promise<string> {
        const dataToShare = {
            identityNumber: this.sessionStorageService.get(SessionStorageKeysEnum.IDENTITY_NUMBER),
            identityType: this.sessionStorageService.get(SessionStorageKeysEnum.IDENTITY_TYPE),
            productId: this.sessionStorageService.get(SessionStorageKeysEnum.PRODUCT),
            officeCode: this.sessionStorageService.get(SessionStorageKeysEnum.OFFICE_CODE),
            customerState: this.sessionStorageService.get(SessionStorageKeysEnum.CUSTOMER_STATE),
            network: this.sessionStorageService.get(SessionStorageKeysEnum.PRIVATE_IP),
            channel: this.channelService.getChannel(),
            utmUuid: this.sessionStorageService.get(SessionStorageKeysEnum.UTM_UUID),
            specificProductInfoUuid: this.sessionStorageService.get(SessionStorageKeysEnum.SPECIFIC_PRODUCT_INFO_UUID),
            site: this.sessionStorageService.get(SessionStorageKeysEnum.SITE),
            firstAuthAttempt: this.sessionStorageService.get(SessionStorageKeysEnum.FIRST_AUTH_ATTEMPT)
        };
        this.redirectService.getEncryptDataToDispatcher(dataToShare);
        return new Promise<string>((resolve, reject) => {
            if (this.initialLoad.useSandboxDispatcher) {
                this.dispatcherService.saveInfoDispacherSandbox(dataToShare)
                    .then(response => {
                        if (response.status === 201) {
                            const responseAuth = response.body;
                            resolve(responseAuth.uuid);
                        } else {
                            reject('Error create uuid');
                        }
                    });
            } else {
                this.dispatcherService.saveInfoAuthenticated(dataToShare).subscribe(response => {
                    const responseAuth = JSON.parse(response._body);
                    if (response.status === 201) {
                        resolve(responseAuth.uuid);
                    } else {
                        reject('Error create uuid');
                    }
                });
            }
        });
    }

    checkChannelConditionsToBlock() {
        this.channelService.getChannel();
        let machineType = Number(this.sessionStorageService.get(SessionStorageKeysEnum.MACHINE_TYPE));
        const mediumType = Number(this.sessionStorageService.get(SessionStorageKeysEnum.MEDIUM_TYPE));
        const selfManagement = this.sessionStorageService.get(SessionStorageKeysEnum.SELF_MANAGEMENT) + '' === 'true';
        logger.log('machineType:', machineType, 'mediumType:', mediumType, 'selfManagment:', selfManagement);
        if (machineType > 10) {
            this.sessionStorageService.save(SessionStorageKeysEnum.HARDWARE, 'new');
            machineType = machineType - 10;
        } else {
            this.sessionStorageService.save(SessionStorageKeysEnum.HARDWARE, 'old');
        }
        const isAllied = mediumType === MediumTypeEnum.ALLIED && (machineType === MachineTypeEnum.ALLIED || machineType === MachineTypeEnum.MOBILE_FORCE_AND_ALLIED);
        const isMobileForce = mediumType === MediumTypeEnum.MOBILE_FORCE && (machineType === MachineTypeEnum.MOBILE_FORCE || machineType === MachineTypeEnum.MOBILE_FORCE_AND_ALLIED);
        const isOffice = mediumType === MediumTypeEnum.OFFICE && !selfManagement && machineType === MachineTypeEnum.OFFICE;
        const isSelfManagement = mediumType === MediumTypeEnum.OFFICE && selfManagement && machineType === MachineTypeEnum.OFFICE_SELF_MANAGEMENT;
        const isMicrofinances = mediumType === MediumTypeEnum.MICROFINANCES && (machineType === MachineTypeEnum.MICROFINANCE);
        logger.log('Channels:', isAllied, isMobileForce, isOffice, isSelfManagement, isMicrofinances);
        const validationResume = {
            isAllied,
            isMobileForce,
            isOffice,
            isSelfManagement,
            isMicrofinances,
            mediumType,
            machineType,
            selfManagement
        };
        let state = false
        if (isAllied || isMobileForce || isOffice || isSelfManagement || isMicrofinances) {
            state = true
        }
        return {
            state,
            validationResume
        };
    }

    async getOffice() {
        const officeCode = this.sessionStorageService.get(SessionStorageKeysEnum.OFFICE_CODE);
        const officeInfoResponse = await this.authenticationRnecService.getOfficeInfo(officeCode);
        const { status } = officeInfoResponse;
        if (status && status === 200) {
            const officeName: string =
                environment.useMDMTVSEndpoint ? officeInfoResponse.body.Desc : officeInfoResponse.properties.description;
            return officeName;
        } else {
            return null;
        }
    }

    saveDataSeller(responseSeller): void {
        try {
            const seller = responseSeller.body.data.info;
            this.saveIfExists(SessionStorageKeysEnum.SELLER_IDENTITY_NUMBER, seller.identityNumber);
            this.saveIfExists(SessionStorageKeysEnum.SELLER_IDENTITY_TYPE, seller.identityType);
            this.saveIfExists(SessionStorageKeysEnum.SELF_MANAGEMENT, seller.selfManagement);
            this.saveIfExists(SessionStorageKeysEnum.IS_FAIR, seller.isFair);
            this.saveIfExists(SessionStorageKeysEnum.SELLER_USER_NAME, seller.username);
            this.saveIfExistsLocalStorage(SessionStorageKeysEnum.SELLER_USER_NAME, seller.username);
            this.saveIfExists(SessionStorageKeysEnum.SELLER_IDENTITY_NUMBER_LDAP, seller.identityNumberLdap);
            seller.isFair && this.saveIfExists(SessionStorageKeysEnum.SELLER_IDENTITY_NUMBER_FAIR, seller.identityNumberLdap);
        } catch (error) {
            throw new Error('Error saveDataSeller()');
        }
    }

    saveIfExists(key, value) {
        value && this.sessionStorageService.save(key, value);
    }

    saveIfExistsLocalStorage(key, value) {
        value && localStorage.setItem(key, value);
    }

    saveDataOfficeByIPTVS(parsedResponseBody: any): void {
        this.sessionStorageService.save(SessionStorageKeysEnum.IP, parsedResponseBody.IpAddress);
        this.sessionStorageService.save(SessionStorageKeysEnum.MAC, parsedResponseBody.MAcAddress);
        this.sessionStorageService.save(SessionStorageKeysEnum.BIOMETRIC_SERIAL, parsedResponseBody.BiometricSerial);
        this.sessionStorageService.save(SessionStorageKeysEnum.USER, parsedResponseBody.User);
        this.sessionStorageService.save(SessionStorageKeysEnum.MACHINE_TYPE, parsedResponseBody.Type);
        this.sessionStorageService.save(SessionStorageKeysEnum.MILESTONE, 'rnec');
        this.sessionStorageService.save(SessionStorageKeysEnum.OFFICE_CODE, parsedResponseBody.OfficeCode);
    }

    saveDataOfficeByIPOLD(parsedResponseBody: any) {
        this.sessionStorageService.save(SessionStorageKeysEnum.IP, parsedResponseBody.ip);
        this.sessionStorageService.save(SessionStorageKeysEnum.MAC, parsedResponseBody.mac);
        this.sessionStorageService.save(SessionStorageKeysEnum.BIOMETRIC_SERIAL, parsedResponseBody.biometricSerial);
        this.sessionStorageService.save(SessionStorageKeysEnum.USER, parsedResponseBody.user);
        this.sessionStorageService.save(SessionStorageKeysEnum.MACHINE_TYPE, parsedResponseBody.machineType);
        this.sessionStorageService.save(SessionStorageKeysEnum.MILESTONE, 'rnec');
        this.sessionStorageService.save(SessionStorageKeysEnum.OFFICE_CODE, parsedResponseBody.office);
    }

    async getPrivateIp(responseFromDispatcher: any) {
        return this.ipUtil.getUserIP().then((ipFromLocal: string) => {
            const ipFromLocalStorage = localStorage.getItem(SessionStorageKeysEnum.PRIVATE_IP);
            const ipFromLauncher: string = !!responseFromDispatcher.specificProductInfo.ipFromLauncher ?
                responseFromDispatcher.specificProductInfo.ipFromLauncher : '';
            if (ipFromLocalStorage && ipFromLocalStorage !== ipFromLocal) {
                logger.log('Saving ipFromLocalStorage: ', ipFromLocalStorage);
                return ipFromLocalStorage;
            } else if (ipFromLauncher && ipFromLauncher !== ipFromLocal) {
                logger.log('Saving ipFromLauncher: ', ipFromLauncher);
                return ipFromLauncher;
            } else {
                logger.log('Saving ipFromLocal: ', ipFromLocal);
                return ipFromLocal
            }
        })
    }

    getFullScreeen(): void {
        addEventListener('click', function () {
            const el = document.documentElement,
                rfs = el['webkitRequestFullScreen']
                    || el['mozRequestFullScreen']
                    || el['msRequestFullscreen']
                    || el.requestFullscreen;
            rfs.call(el);
        });
    }

    getQueryParams() {
        const url = window.location.search.substring(1);
        const llaves = url.split('&');
        if (llaves[0] === '') {
            return;
        }
        this.sessionStorageService.clear();
        this.sessionStorageService.save(SessionStorageKeysEnum.QUERY_PARAMS_COMPLETE, url);
        for (const value of llaves) {
            const par = value.split('=');
            if (par[0] && par[1]) {
                this.sessionStorageService.save(par[0], par[1]);
            }
        }
    }

    checkEmptyDataSite() {
        const site = this.sessionStorageService.get(SessionStorageKeysEnum.SITE);
        const specificProductInfoUuid = this.sessionStorageService.get(SessionStorageKeysEnum.SPECIFIC_PRODUCT_INFO_UUID);
        if (site === null || specificProductInfoUuid === null) {
            this.redirectService.quit();
        }
    }

    callModalServiceError(errorCode: ServiceErrorEnum, callbackYes: Function) {
        let errTitle = '';
        let errDesc = '';
        this.modalFunctionYes = callbackYes;
        switch (errorCode) {
            case ServiceErrorEnum.GET_DATA_DISPATCHER_ERROR:
                errTitle = `Problemas al consultar la información`;
                errDesc = `No logramos consultar la información debido a un problema de comunicación. Verifica tu conexión a
                internet e intenta nuevamente. (${ServiceErrorEnum.GET_DATA_DISPATCHER_ERROR})`;
                break;
            case ServiceErrorEnum.CLIENT_ASSOCIATION_WITH_SELLER_SERVICE_ERROR:
                errTitle = `Error validando información`;
                errDesc = `Se han encontrado algunas inconsistencias en la información. (${ServiceErrorEnum.CLIENT_ASSOCIATION_WITH_SELLER_SERVICE_ERROR})`;
                break;
            case ServiceErrorEnum.SAVE_DATA_DISPATCHER_ERROR:
                errTitle = `Problemas al registrar la información`;
                errDesc = `No logramos guardar la información debido a un problema de comunicación. Verifica tu conexión a
                    internet e intenta nuevamente. (${ServiceErrorEnum.SAVE_DATA_DISPATCHER_ERROR})`;
                break;
            case ServiceErrorEnum.GET_SELLER_NOT_FOUND_ERROR:
                errTitle = `Problemas al consultar la información`;
                errDesc = `No logramos consultar la información debido a un problema de comunicación. Verifica tu conexión a
                internet e intenta nuevamente. (${ServiceErrorEnum.GET_SELLER_NOT_FOUND_ERROR})`;
                break;
            case ServiceErrorEnum.GET_SELLER_SERVICE_ERROR:
                errTitle = `Problemas al consultar la información`;
                errDesc = `No logramos consultar la información debido a un problema de comunicación. Verifica tu conexión a
                internet e intenta nuevamente. (${ServiceErrorEnum.GET_SELLER_SERVICE_ERROR})`;
                break;
            case ServiceErrorEnum.WRONG_CHANNEL_ERROR:
                errTitle = `Error en el canal de servicio`;
                errDesc = `Valida el canal de servicio o solicita al asesor comunicarse con soporte para solicitar la
                reconfiguración del dispositivo. (${ServiceErrorEnum.WRONG_CHANNEL_ERROR})`;
                break;
            case ServiceErrorEnum.SAVE_DATA_SELLER_ERROR:
                errTitle = `Problemas al consultar la información`;
                errDesc = `No logramos consultar la información debido a un problema de comunicación. Verifica tu conexión a
                internet e intenta nuevamente. (${ServiceErrorEnum.SAVE_DATA_SELLER_ERROR})`;
                break;
            case ServiceErrorEnum.ABSTENTION_LIST_ERROR:
                errTitle = `Error validando información`;
                errDesc = `Se han encontrado algunas inconsistencias en la información. (${ServiceErrorEnum.ABSTENTION_LIST_ERROR})`;
                break;
            case ServiceErrorEnum.GET_OFFICE_INFO_BY_CODE_SERVICE_ERROR:
                errTitle = `Problemas al consultar la información`;
                errDesc = `No logramos consultar la información debido a un problema de comunicación. Verifica tu conexión a
                internet e intenta nuevamente. (${ServiceErrorEnum.GET_OFFICE_INFO_BY_CODE_SERVICE_ERROR})`;
                break;
            case ServiceErrorEnum.GET_OFFICE_BY_IP_SERVICE_ERROR:
                errTitle = `Presentamos un problema de configuración del dispositivo`;
                errDesc = `Solicita al asesor comunicarse con soporte para solicitar la reconfiguración del dispositivo
                y luego actualiza la página. (${ServiceErrorEnum.GET_OFFICE_BY_IP_SERVICE_ERROR})`;
                break;
            case ServiceErrorEnum.VALIDATE_CODE_OFFICE_ERROR:
                errTitle = `Presentamos un problema de configuración del dispositivo`;
                errDesc = `Solicita al Jefe de Servicios comunicarse con soporte para solicitar la reconfiguración del dispositivo.
                        y luego actualiza la página. (${ServiceErrorEnum.VALIDATE_CODE_OFFICE_ERROR})`;
                break;
            case ServiceErrorEnum.CUSTOMER_STATE_ERROR:
                errTitle = `Problemas al consultar la información`;
                errDesc = `No logramos consultar la información debido a un problema de comunicación. Verifica tu conexión a
                    internet e intenta nuevamente. (${ServiceErrorEnum.CUSTOMER_STATE_ERROR})`;
                break;
        }
        this.setModalTitles(errTitle, errDesc);
        this.loaderBdb.nativeElement.closeLoader();
        this.modalBdb.nativeElement.openAlert();
    }

    setModalTitles(title: string, subtitle: string) {
        this.modalBdb.nativeElement.titleModal = title
        this.modalBdb.nativeElement.subTitle = subtitle
    }

    actionButtomModalBdb() {
        this.modalFunctionYes()
    }
}



// WEBPACK FOOTER //
// ./src/app/bdb-handler/bdb-handler.component.ts